import { Component, EventEmitter, HostBinding, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { isUserNotBasic } from '@models/utils';
import { AuthService, UserDataModel } from '@modules/auth';
import { LikesService } from '@services/LikesService/likes.service';
import { Observable, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-likes-panel',
  templateUrl: './likes-panel.component.html',
  styleUrls: ['./likes-panel.component.scss']
})
export class LikesPanelComponent implements OnInit, OnDestroy {

  @Input() likesCount: number;
  @Input() lastLikedUser?: UserDataModel;

  @Input() contentId: number;
  @HostBinding('class.in-comments')
  @Input() isComments: boolean = false;

  public likesList$: Observable<UserDataModel[]>;
  public isAdmin: boolean = false;

  public openLikesList: EventEmitter<boolean> = new EventEmitter();
  public showModal: Observable<boolean>;

  private destroy$ = new Subject<void>();

  constructor(
    public authService: AuthService,
    private likesService: LikesService,
    private router: Router,
  ) { 
    this.showModal = this.openLikesList.asObservable().pipe(
      map((isOpen: boolean) => this.isAdmin && isOpen),
    )
  }

  public get nameAndCounter(): string {
    const userName = `${this.lastLikedUser?.userName}`
    return `${userName} ${!this.isAdmin ? 'and others' : (this.likesCount <= 1 ? '' : `and ${this.likesCount - 1} more`)}`;
  }

  public ngOnInit(): void {
    this.authService.currentUser$.pipe(takeUntil(this.destroy$)).subscribe(user => {
      this.isAdmin = isUserNotBasic(user);
    });
    this.likesList$ = (
      this.isComments ?
      this.likesService.getReplyLikesById(this.contentId) :
      this.likesService.getPostLikesById(this.contentId)
    ).pipe(
      map((response) => response.data),
    )
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public onLabelClick() {
    if (!this.isAdmin) return;
    this.openLikesList.next(true);
  }

  public openUrl(url: string) {
    this.openLikesList.next(false);
    this.router.navigateByUrl(url)
  }
}
